// extracted by mini-css-extract-plugin
export default {"purchases":"purchases_purchases__IL-4T"};